import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WelcomePage.css';

const WelcomePage = () => {
    const navigate = useNavigate();

    const handleLoginClick = () => {
        navigate('/login');
    };

    return (
        <div className="welcome-container">
            <div className="welcome-card">
                <div className="welcome-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-book-open">
                        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                    </svg>
                </div>
                <h1 className="welcome-title">Welcome to Milma Docs</h1>
                <p className="welcome-subtitle">
                    Your central hub for all technical documentation and knowledge.
                </p>
                <button className="welcome-login-button" onClick={handleLoginClick}>
                    Go to Login
                </button>
            </div>
        </div>
    );
};

export default WelcomePage;
